export default "__VITE_ASSET__CkudbB8Y__"